import React from "react";
import { Chip, SxProps } from "@mui/material";
import { MyResponse } from "../../types";

export interface Props {
  response: MyResponse;
  sx?: SxProps;
}

const SCHEDULED_STATES = ["SC", "ACS"];

export const ResponseState = ({ response, sx }: Props) => {
  if (SCHEDULED_STATES.includes(response.campaignState)) {
    return (
      <Chip
        label="Scheduled"
        sx={{
          ...sx,
          backgroundColor: "var(--color-blue)",
          color: "black",
        }}
        variant="outlined"
      />
    );
  }

  return (
    <>
      {!response.submitted &&
        new Date(response.campaignDueDate) > new Date() && (
          <Chip
            label="Open"
            sx={{
              ...sx,
              backgroundColor: "var(--color-green)",
              color: "black",
            }}
            variant="outlined"
          />
        )}
      {!response.submitted &&
        new Date(response.campaignDueDate) <= new Date() && (
          <Chip
            label="Past Due"
            sx={{
              ...sx,
              backgroundColor: "var(--color-yellow)",
              color: "black",
            }}
            variant="outlined"
          />
        )}
    </>
  );
};
